export class SearchCompletion {
  constructor(
    public text: string,
    public icon?: string,
    public svgIcon?: string,
    public value?: string,
    public optionSelected?: (option: string) => void
  ) {}
}
